import { render, staticRenderFns } from "./ViewerHeaderNoImageTheme.vue?vue&type=template&id=2196b03a&scoped=true"
import script from "./ViewerHeaderNoImageTheme.vue?vue&type=script&lang=js"
export * from "./ViewerHeaderNoImageTheme.vue?vue&type=script&lang=js"
import style0 from "./ViewerHeaderNoImageTheme.vue?vue&type=style&index=0&id=2196b03a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2196b03a",
  null
  
)

export default component.exports